import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import HistoryFilterSelectBottomSheet from '@di-shared/features/history/filter/HistoryFilterSelectBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function HistoryFilterSelectPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <HistoryFilterSelectBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
